import algoliasearch from "algoliasearch/lite.js";
import instantsearch from "instantsearch.js";

/**
 * Strip `configure` from each index in state so it is never synced to the URL.
 * Configure (filters, getRankingInfo, etc.) stays hardcoded per page.
 */
function stateWithoutConfigure(state) {
  if (!state || typeof state !== "object") return state;
  const out = {};
  for (const [key, value] of Object.entries(state)) {
    if (value && typeof value === "object" && "configure" in value) {
      const { configure: _c, ...rest } = value;
      out[key] = Object.keys(rest).length ? rest : undefined;
    } else {
      out[key] = value;
    }
  }
  return Object.fromEntries(Object.entries(out).filter(([, v]) => v !== undefined));
}

export const createSearchStateMapping = (initialHasCharliAttribution = false) => {
  let hasCharliAttribution = Boolean(initialHasCharliAttribution);

  return {
    stateToRoute(uiState) {
      const { c: _c, ...routeState } = stateWithoutConfigure(uiState);

      if (!hasCharliAttribution) return routeState;

      return { ...routeState, c: "1" };
    },
    routeToState(routeState) {
      const { c, ...searchRouteState } = routeState;
      hasCharliAttribution = c === "1";

      let state = searchRouteState;
      if (searchRouteState.query) {
        state = {
          ...searchRouteState,
          "": { query: searchRouteState.query },
        };
      }

      return stateWithoutConfigure(state);
    },
  };
};

export const createNewSearchInstance = ({ searchClient } = {}) => {
  const hasCharliAttribution =
    new URLSearchParams(window.location.search).get("c") === "1";

  return instantsearch({
    searchClient:
      searchClient || algoliasearch(algolia.application_id, algolia.search_api_key),
    userToken: algolia.user_info.user_token,
    routing: {
      stateMapping: createSearchStateMapping(hasCharliAttribution),
    },
  });
};
